import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  expairyPopUpContainer: {
    position: "fixed",
    bottom: 0,
    height: 382,
    width: 477,
    border: "1px solid #EEEEEE",
    background: "#FFFFFF",
    boxShadow: "0px 0px 32px rgba(0, 0, 0, 0.1)",
    zIndex: "1100",
    borderRadius: "10px 10px 0px 0px",
    padding: "20px",
    left: "calc(50vw - 238px)",
  },
  closeIcon: {
    position: "absolute",
    right: "24.5px",
    top: "25.5px",
    cursor: "pointer",
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  popHeader: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#333333",
  },
  popTitle: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#666666",
    marginTop: "8px",
    width: "401px",
  },
  imageDiv: {
    width: "437px",
    height: "200px",
    borderRadius: "8px",
    marginTop: "16px",
    border: "1px solid #dadada",
  },
  tryButton: {
    width: "437px !important",
    height: "40px",
    maxWidth: "437px",
    marginTop: "16px",
    textTransform: "none",
  },
  highlight: {
    fontWeight: 600,
  },
}));
